export default __webpack_public_path__ + "static/media/portugal.2459d19f.png";